import { useEffect, useState } from 'react';
import { getElevation } from 'actions/routePlannerActions';
import { routeToCoordsString } from 'utils/parsingUtils';

export const getGraphLinesWithRelAlt = (groundGraphLine, droneGraphLine) => {
  let homeElv = groundGraphLine[0];
  const droneRelAltLine = droneGraphLine.map((point, idx) => {
    return { x: point.x, y: homeElv.y + droneGraphLine[idx].y };
  });
  return { groundGraphLine, droneGraphLine: droneRelAltLine };
};

export const parseRouteIntoGraphLines = (route, startingPointElevation) => {
  const groundGraphLine = [];
  const droneGraphLine = [];

  route.features.forEach((feature, index) => {
    const elevation =
      parseInt(feature.properties.elevation) - startingPointElevation;
    const relativeAlt = parseInt(feature.properties.relativeAltitude);
    const groundGraphPoint = { x: index, y: elevation };
    const droneGraphPoint = { x: index, y: relativeAlt };
    groundGraphLine.push(groundGraphPoint);
    droneGraphLine.push(droneGraphPoint);
  });
  return { groundGraphLine, droneGraphLine };
};

export const checkIfRouteHasElevationData = route => {
  return (
    route?.features[0].properties.elevation &&
    route?.features[0].properties.relativeAltitude
  );
};

export const fetchElevationDataForRoute = async (
  route,
  startingPointElevation
) => {
  try {
    const elevationQueryString = routeToCoordsString(route);
    if (elevationQueryString) {
      const elevationPoints = await getElevation(elevationQueryString);

      const groundGraphLine = [];
      const droneGraphLine = [];

      route.features.forEach((feature, index) => {
        const elevation =
          parseInt(elevationPoints.data.results[index].elevation) -
          startingPointElevation;
        const relativeAlt = parseInt(feature.properties.relativeAltitude);
        const groundGraphPoint = { x: index, y: elevation };
        const droneGraphPoint = { x: index, y: relativeAlt };
        groundGraphLine.push(groundGraphPoint);
        droneGraphLine.push(droneGraphPoint);
      });

      return { groundGraphLine, droneGraphLine };
    }
  } catch (err) {
    console.log(err);
  }
};

export const useElevationDataForRoute = (geoJson, startingPointElevation) => {
  const [graphLines, setGraphLines] = useState();

  const fetchElevation = async (route, startingPointElevation) => {
    const fetchElevationGraphLines = await fetchElevationDataForRoute(
      route,
      startingPointElevation
    );
    setGraphLines(fetchElevationGraphLines);
  };

  // On change route run this effect
  useEffect(() => {
    if (geoJson) {
      // Check if elevation data exists in geoJson
      const routeHasElevationData = checkIfRouteHasElevationData(geoJson);
      if (routeHasElevationData) {
        // Parse the route data into ground and drone altitude graph lines
        const parsedGraphLines = parseRouteIntoGraphLines(
          geoJson,
          startingPointElevation
        );
        setGraphLines(parsedGraphLines);
      } else {
        // Fetch the elevation data for the route
        fetchElevation(geoJson, startingPointElevation);
      }
    } else {
      setGraphLines(null);
    }
  }, [geoJson, startingPointElevation]);

  return [graphLines];
};
